import { render } from "./EditWarehousePage.vue?vue&type=template&id=854e5e4c"
import script from "./EditWarehousePage.vue?vue&type=script&lang=js"
export * from "./EditWarehousePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__